import {chevronRightCircleSvg as Icon__small__chevronRightCircleSvg} from '../Icon__small/Icon__small--chevronRightCircle.js'

export var chevronRightCircle = {
  name: 'chevronRightCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chevronRightCircleSvg,
};
